import { styled } from "@mui/system";
import { Button } from "@mui/material";
import { Accordion } from "./components/Accordion/CustomAccordion";

export const TrackNSwitchAccountBtn = styled(Button, {
  shouldForwardProp: prop => prop !== "buttonColor"
})(({ theme, buttonColor = "#000" }) => ({
  boxSizing: "content-box",
  borderRadius: "6.25rem",
  border: `1px solid ${buttonColor}`,
  fontSize: "0.75rem",
  textAlign: "center",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "1rem",
  color: buttonColor,
  textTransform: "none",
  letterSpacing: "0rem",
  padding: "0.5rem 0.75rem",
  [theme.breakpoints.up("sm")]: {
    textAlign: "unset",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    padding: "0.75rem 1.25rem"
  }
}));

export const StyledAdditionalInfoAccordion = styled(Accordion)(({ theme, showChip }) => ({
  "& .MuiAccordion-root": {
    borderTop: "none",
    width: "100%",
    borderRadius: "10px",
    border: !showChip ? "2px solid #E9E9E9" : "1px solid var(--colour-outline-primary)",
    padding: "20px"
  },
  "& .MuiAccordionSummary-content": {
    "& .accordionTitle": {
      "& .title": {
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "28px"
      }
    },
    "&.Mui-expanded": {
      "& .activePanel": {
        display: "none"
      },
      "& .accordionTitle": {
        paddingLeft: 0
      }
    }
  },
  "& .MuiAccordionDetails-root": {
    paddingBottom: "1.5rem",
    marginBottom: "0px",
    [theme.breakpoints.up("sm")]: {
      paddingBottom: "unset"
    }
  }
}));

export const StyledAccordionContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  marginTop: "1rem"
}));
